import { useCallback } from 'react'
import { CustomFile } from '../../../model/File'
import { UserFriendlyError } from '../../../model/Error'
import { fetchFile } from '../../../store/cache/files/api'
import { base64StringToBlob } from 'blob-util'
import { fileKeys } from './files.keys'
import { useQueryClient } from '@tanstack/react-query'
import { usePrintablePdf } from '../../../core/hooks/usePritablePdfContext'

export type DirectPrintableFileVariable = {
  fileId: number
}

export const useDirectPrintFile = () => {
  const queryClient = useQueryClient()
  const { printBlob } = usePrintablePdf()

  const print = useCallback((file: CustomFile) => {
    if (!file.base64 || file.extension !== 'pdf') {
      throw new Error(`Base64 content missing or extension is not "PDF" on file ${file.id}`)
    }
    const splitted = file.base64.split(',')

    printBlob(base64StringToBlob(splitted[1]))
  }, [printBlob])

  return async ({ fileId }: DirectPrintableFileVariable) => {
    const data = await queryClient.fetchQuery<CustomFile>({
      queryKey: fileKeys.detail(fileId),
      queryFn: async () => {
        const { data, ok } = await fetchFile(fileId)

        if (!data || !ok) {
          throw new UserFriendlyError(
            'error',
            `Impossible de récupérer le fichier ${fileId}`,
            `Une erreur technique s'est produite`,
          )
        }
        return data
      },
    })

    return print(data)
  }
}
